// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CollapseContainer{transition:.2s}.CollapsedBlock{transition:.4s;overflow:hidden}", ""]);
// Exports
module.exports = exports;
